/* eslint-disable @typescript-eslint/no-explicit-any */
import { ENTRY_DATA_SECTION_KEYS } from "@frontend/common";

import { DealLaScSection } from "@/types/dealLaSc.types";
import {
  useTableCreatorFocusStatus,
  DEFAULT_FOCUS_STATUS,
} from "@FillInTableContainer/shared/context/TableCreatorFocusStatusContext";
import { useTableCreatorCurrentHistory } from "@FillInTableContainer/shared/context/TableCreatorHistoryContext";
import {
  useTableCreatorPositionInfo,
  DEFAULT_POSITION_INFO,
} from "@FillInTableContainer/shared/context/TableCreatorPositionInfoContext";
import {
  useValidatedInTableCreator,
  DEFAULT_VALIDATED_INFO,
} from "@FillInTableContainer/shared/context/ValidatedInTableCreatorContext";
import { useEntryDataState } from "@stores/entryData";
import { getPressIdFromURL } from "@utils/getStateFromURL";

import type { ArticleEntryData } from "@/types/articleEntryData.types";

interface UseHandleGroupShellReturn {
  deleteSubGroupShellData: () => void;
}

interface Props {
  positionPropsInfo: {
    groupTableKey: DealLaScSection;
    groupTableIndex: number;
    groupShellKey: string | null;
    groupShellIndex: number | null;
    subGroupShellIndex: number;
    subGroupShellKey: string | null;
    tableKey: string | null;
    tableIndex: number;
  };
}

export const useDeleteDealLaScKeyCommentSubGroupShell = ({
  positionPropsInfo,
}: Props): UseHandleGroupShellReturn => {
  const {
    groupTableKey,
    groupTableIndex,
    groupShellKey,
    groupShellIndex,
    subGroupShellIndex,
    subGroupShellKey,
    tableKey,
    tableIndex,
  } = positionPropsInfo;

  const articleSection = ENTRY_DATA_SECTION_KEYS.dealsLaSc;
  const [entryData, setEntryData] = useEntryDataState(getPressIdFromURL());
  const { changeCurrentHistory } = useTableCreatorCurrentHistory();
  const { changeFocusStatus } = useTableCreatorFocusStatus();
  const { info, changeInfo } = useTableCreatorPositionInfo();
  const { changeValidatedInfo } = useValidatedInTableCreator();

  const deleteSubGroupShellData = () => {
    if (info.subGroupShellKey !== "Key Comment List") return;

    const deleteKeyCommentListSubGroupShell = (): ArticleEntryData => {
      const remainingList =
        entryData[articleSection]?.["Key Comment List"]?.filter(
          (_, idx) => idx !== info.subGroupShellIndex,
        ) ?? [];
      const newFirstItem = remainingList[0];
      return {
        ...entryData,
        [articleSection]: {
          ...entryData[articleSection],
          "Key Comment": {
            ...entryData[articleSection]?.["Key Comment"],
            Quote: {
              ...entryData[articleSection]?.["Key Comment"]?.Quote,
              value: newFirstItem?.["Comment Quote"]?.value ?? [],
            } as any,
            Spokesperson: {
              ...entryData[articleSection]?.["Key Comment"]?.Spokesperson,
              value: newFirstItem?.["Comment Spokesperson"]?.value ?? [],
            } as any,
          } as any,
          "Key Comment List": remainingList,
        },
      };
    };

    setEntryData(deleteKeyCommentListSubGroupShell());
    changeCurrentHistory({
      entryData: deleteKeyCommentListSubGroupShell(),
      changedDataInfo: {
        target: "subGroupShell",
        action: "delete",
        position: {
          groupShellKey,
          groupTableIndex,
          tableKey,
          tableIndex,
          groupTableKey,
          groupShellIndex,
          subGroupShellIndex,
          subGroupShellKey,
          shellKey: null,
          shellIndex: null,
          valueIndex: null,
          value: null,
        },
      },
    });

    changeValidatedInfo(DEFAULT_VALIDATED_INFO);
    changeFocusStatus(DEFAULT_FOCUS_STATUS);
    changeInfo(DEFAULT_POSITION_INFO);
  };

  return {
    deleteSubGroupShellData,
  };
};
